import createVueApp from '@/common/createApp'

Styxie.Initializers.ProfileAccount = {
  show: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/account/index.vue')
    createVueApp(Component, { props })
  }
}
